import React from 'react';
import I18n from 'modules/i18n';
import { LinkButton } from '@/components/ui/Buttons';
import { truncationRowAttrs } from '../TruncatedCorrelationsList';

interface SeeMoreButtonProps {
  label: string;
  loading: boolean;
  style?: React.CSSProperties;
  onClick: () => void;
}

// Loads the next batch of a standards level (roots, or one category's children). An <li>, because it
// always sits at the end of that level's list.
const SeeMoreButton = ({ label, loading, style, onClick }: SeeMoreButtonProps) => (
  <li className="tw-py-1" style={style} {...truncationRowAttrs()}>
    <LinkButton
      aria-busy={loading}
      aria-label={`${I18n.t('see_more')} ${label}`}
      className="tw-p-0 tw-text-sm"
      disabled={loading}
      onClick={onClick}
    >
      {loading ? I18n.t('loading') : I18n.t('see_more')}
    </LinkButton>
  </li>
);

export default SeeMoreButton;
